import clsx from 'clsx'
import { useRouter } from 'next/dist/client/router'
import Link from 'next/link'
import type { FunctionComponent } from 'react'
import { InternalLink } from '../../const/Links'
import { menuItems } from '../../const/MenuItems'
import { Translation, useTranslate } from '../../contexts/TranslationContext'
import style from './Breadcrumbs.module.sass'

type BreadcrumbsProps = {
	items?: { title: string | undefined; link?: string; id: string }[]
}

export const Breadcrumbs: FunctionComponent<BreadcrumbsProps> = ({ items }) => {
	const router = useRouter()
	const urlPathName = router.pathname
	const translate = useTranslate()

	const menuItemFromUrl = menuItems.find((item) => item.paths?.find((path) => urlPathName.includes(path)))

	return (
		<div className={clsx(style.row, !items && style.rowMobileHidden)}>
			<Link href={InternalLink.Home} className={style.item} title={translate('breadcrumbs.home')}>
				<span className={style.itemText}>
					<Translation tr="breadcrumbs.home" />
				</span>
			</Link>
			{menuItemFromUrl && !menuItemFromUrl.paths.includes(urlPathName) && (
				<Link href={menuItemFromUrl.link} className={style.item} title={menuItemFromUrl.link}>
					<span className={style.itemText}>{menuItemFromUrl.breadCrumbsTitle || menuItemFromUrl.label}</span>
				</Link>
			)}
			{items &&
				items.map(
					(item) =>
						item &&
						(item.link ? (
							<Link href={item.link} key={item.id} className={style.item} title={item.title}>
								<span className={style.itemText}>{item.title}</span>
							</Link>
						) : (
							<span className={style.item} key={item.id}>
								<span className={style.itemText}>{item.title}</span>
							</span>
						)),
				)}
		</div>
	)
}
